import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';

const ProtectedRoute = ({ children }) => {
  const { currentUser, isLoggingOut, authReady } = useAuth();
  const { t, language } = useLanguage();

  // 🚀 優化：認證系統未就緒時顯示輕量級載入畫面
  if (!authReady) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-50 to-secondary-50">
        <div className="text-center">
          <div className="inline-block w-12 h-12 border-4 border-primary-200 border-t-primary-600 rounded-full animate-spin"></div>
          <p className="mt-4 text-gray-600 font-medium">
            {t('common.checkingAuth') || 'Checking authentication...'}
          </p>
        </div>
      </div>
    );
  }

  // 正在登出時顯示載入畫面
  if (isLoggingOut) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-50 to-secondary-50">
        <div className="text-center">
          <div className="inline-block w-12 h-12 border-4 border-primary-200 border-t-primary-600 rounded-full animate-spin"></div>
          <p className="mt-4 text-gray-600 font-medium">
            {t('common.loggingOut') || 'Logging out...'}
          </p>
        </div>
      </div>
    );
  }

  // 🎯 修正：未登入則重定向到當前語言的認證頁面
  if (!currentUser) {
    return <Navigate to={`/${language}/auth`} replace />;
  }

  // 已登入則渲染子組件
  return children;
};

export default ProtectedRoute;